const animate = {
  init: function () {
    animate.events();
  },

  events: function () {
    animate.elements();
    animate.roll();

    // On scroll
    $(window).on("scroll", function () {
      animate.elements();
      animate.roll();
    });
  },

  elements: function () {
    var windowScrolled = $(window).scrollTop() + $(window).height();
    var index = 0;
    var prevOffset = 0;

    if ($(".entry-content").length) {
      $(".entry-content").each(function () {
        if (!$(this).closest(".overlay").length) {
          $(this)
            .find(
              'p, h1, h2, h3, h4, h5, h6, .video, blockquote, li, hr, .gallery, [href$=".pdf"], [href$=".doc"], [href$=".docx"], [href$=".ppt"], [href$=".pptx"], [href$=".rar"], [href$=".xls"], [href$=".xlsx"], [href$=".zip"], [href$=".jpg"], [href$=".gif"], [href$=".svg"], [href$=".jpeg"], .scrolltable'
            )
            .addClass("animate animate--fade-up");
        }
      });
    }

    $(".animate")
      .not(".animate-animated")
      .each(function () {
        var block = $(this);
        var currentOffset = block.offset().top;

        if (prevOffset != currentOffset) {
          prevOffset = currentOffset;
          index = 0;
        }
        var showAt;
        if ($(window).width > 900) {
          // Show at 20% from bottom
          showAt = windowScrolled * 0.8;
        } else if ($(window).width > 600) {
          // Show at 100px from bottom
          showAt = windowScrolled - 100;
        } else {
          // Show at 50px from bottom
          showAt = windowScrolled - 50;
        }

        // Add class if in viewport
        if (currentOffset + block.height() < showAt || currentOffset < showAt) {
          // If multiple elements at the same top offset, add classes in chain
          setTimeout(function () {
            block.addClass("animate-animated");
          }, index * 100);
          index++;
        }
      });
  },

  roll: function () {
    var windowScrolled = $(window).scrollTop() + $(window).height();

    $(".roll")
      .not(".roll-rolled")
      .each(function () {
        var block = $(this);
        var currentOffset = block.offset().top;

        var showAt;
        if ($(window).width > 900) {
          // Show at 25% from bottom
          showAt = windowScrolled * 0.75;
        } else {
          // SHow at 5% from bottom
          showAt = windowScrolled * 0.95;
        }
        if (currentOffset + block.height() < showAt || currentOffset < showAt) {
          var count_to = block.data("count");
          if (typeof count_to === "number") {
            block.prop("Counter", 0).animate(
              {
                Counter: count_to,
              },
              {
                duration: 4000,
                easing: "swing",
                step: function (now) {
                  block.text(Math.ceil(now));
                },
              }
            );
          } else {
            block.text(count_to);
          }

          block.addClass("roll-rolled");
        }
      });
  },
};
export default animate;
